/**
 * CL-ACCESS-CLIENT-MODULES-001B — Canonical client portal assignment runtime (Band B).
 */

import { buildProjectAssignmentDocId } from "./projectCollaboratorPermissions";
import { CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST } from "./clientPortalModulePermissionKeys";

function safeStr(value) {
  return String(value ?? "").trim();
}

export function buildCanonicalAuthAssignmentDocId(projectId = "", authUid = "") {
  const pid = safeStr(projectId);
  const uid = safeStr(authUid);
  if (!pid || !uid) return null;
  return buildProjectAssignmentDocId(pid, { uid });
}

export function isValidCanonicalAuthAssignment(
  assignmentDoc = null,
  { projectId = "", authUid = "" } = {}
) {
  if (!assignmentDoc || typeof assignmentDoc !== "object") return false;
  const pid = safeStr(projectId);
  const uid = safeStr(authUid);
  if (!pid || !uid) return false;
  if (safeStr(assignmentDoc.projectId) !== pid) return false;
  const assignmentUserId = safeStr(assignmentDoc.userId || assignmentDoc.authUid);
  if (assignmentUserId !== uid) return false;
  if (safeStr(assignmentDoc.status || "active").toLowerCase() !== "active") return false;
  return true;
}

export function readExplicitClientModuleGrant(permissions = {}, key = "") {
  return permissions?.[key] === true;
}

/**
 * Assignment-first client module flags: explicit boolean true only; fail closed otherwise.
 */
export function resolveAssignmentFirstClientPortalModulePermissions({
  assignmentDoc = null,
  projectId = "",
  authUid = "",
} = {}) {
  const flags = CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});

  if (!isValidCanonicalAuthAssignment(assignmentDoc, { projectId, authUid })) {
    return flags;
  }

  const permissions =
    assignmentDoc?.permissions && typeof assignmentDoc.permissions === "object"
      ? assignmentDoc.permissions
      : {};

  CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.forEach((key) => {
    flags[key] = readExplicitClientModuleGrant(permissions, key);
  });
  return flags;
}

export function buildEmptyClientPortalModulePermissionFlags() {
  return CLIENT_PORTAL_MODULE_PERMISSION_KEY_LIST.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
}
